import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import ToggleButtonGroup from '../ToggleButtonGroup'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * If exists, calls it with the value for custom additional actions
   * Formik setFieldValue will always run before it
   */
  onChange: PropTypes.func,
}

/**
 * Connects the ToggleButtonGroup with Formik.
 */
function FormikToggleButtonGroup(props) {
  const { id, onChange = null } = props ?? {}

  return (
    <Field name={id}>
      {({ field, form }) => (
        <ToggleButtonGroup
          {...props}
          id={id}
          onChange={(value) => {
            form.setFieldValue(id, value)
            if (onChange) {
              onChange(value)
            }
          }}
          value={field.value}
          // onBlur={() => { // right now this field doesn't show errors
          //   form.setFieldTouched(id, true) // set the touched flag (important for displaying errors)
          // }}
          // errors={meta.touched && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikToggleButtonGroup.propTypes = propTypes

export default FormikToggleButtonGroup
